import { Component, Input, OnInit } from '@angular/core';
import { IItemInputDateTime } from './intefaces/iitem-input-day-time';

@Component({
  selector: 'app-input-day-time',
  templateUrl: './input-day-time.component.html',
  styleUrls: ['./input-day-time.component.sass'],
})
export class InputDayTimeComponent implements OnInit {
  @Input()
  props: {
    isActive: boolean;
    items: IItemInputDateTime[];
  }

  selectedValue: any;
  days = [
    { value: 0, viewValue: '' },
    { value: 1, viewValue: 'DOM' },
    { value: 2, viewValue: 'SEG' },
    { value: 3, viewValue: 'TER' },
    { value: 4, viewValue: 'QUA' },
    { value: 5, viewValue: 'QUI' },
    { value: 6, viewValue: 'SEX' },
    { value: 7, viewValue: 'SAB' },
  ];

  constructor() {}

  ngOnInit(): void {}

  public add() {
    this.props.items.push({ active: true, day: 0, startTime: '', endTime: '', isValid: true });
  }

  public remove(idx: number) {
    this.props.items.splice(idx, 1);
  }

  public endTimeValidate(idx: number, startTime: any, endTime: any){
    let start = startTime.split(":").length == 2 ? +startTime.split(":")[0] * 60 + +startTime.split(":")[1] : 0;
    let end = endTime.split(":").length == 2 ? +endTime.split(":")[0] * 60 + +endTime.split(":")[1] : 0;

    if(start > end)
      this.props.items[idx].endTime = startTime;
  }
}
